import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import DescriptionIcon from "@mui/icons-material/Description";
import ViewQuiltIcon from "@mui/icons-material/ViewQuilt";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";

import Introduction from "./components/Introduction";

import NavigationFooter from "../../helper-components/misc/NavigationFooter";
import CustomForm from "../../helper-components/form/CustomForm";
import PaperText from "../../helper-components/misc/PaperText";
import CustomButton from "../../helper-components/input/CustomButton";

import { getLanguage } from "../../config/language/language";
import StatisticsGraphs from "./components/StatisticsGraphs";

/**
 * The homepage.
 */
export default function Home(props) {
    const isLoggedIn = props.user.isLoggedIn;

    return (
        <Container maxWidth="xl" sx={{ mb: 2, mt: 2 }}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <CustomForm title={getLanguage().HOME_OVERVIEW_TITLE} subtitle={getLanguage().HOME_OVERVIEW_SUBTITLE} icon={<ViewQuiltIcon />} />
                </Grid>

                <Introduction {...props} />

                {isLoggedIn && (
                    <Grid item xs={12} style={{ paddingTop: 0 }}>
                        <PaperText
                            p={0}
                            whiteSpace="pre-wrap"
                            value={
                                <CustomButton
                                    {...props}
                                    title="Create New Examination"
                                    onClick={() => props.browser.navigate("/database/examinations/new")}
                                    variant="contained"
                                    fullWidth
                                    startIcon={<DescriptionIcon />}
                                    className="button-large-v2"
                                />
                            }
                        />
                    </Grid>
                )}

                {isLoggedIn && <StatisticsGraphs {...props} />}

                {isLoggedIn && (
                    <NavigationFooter
                        rows={1}
                        options={[
                            {
                                path: `/database/examinations`,
                                title: "View All Examinations",
                                variant: "outlined",
                                icon: <DescriptionIcon />
                            },
                            {
                                path: `/database/patients`,
                                title: "Manage Patients",
                                variant: "outlined",
                                icon: <PermContactCalendarIcon />
                            }
                        ]}
                    />
                )}
            </Grid>
        </Container>
    );
}
